import { Component, inject, OnInit } from '@angular/core';
import { TableLazyLoadEvent, TableRowSelectEvent } from 'primeng/table';
import { SequenceService } from '../../services/sequence/sequence.service';
import { MessageService } from 'primeng/api';
import { MPISequenceDto } from '../../../../../express-tRPC/src/api/sequences/types';
import {environment} from '../../../environments/environment';
import { TrpcService } from '../../services/trpc/trpc.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-sequence-management',
  templateUrl: './sequence-management.component.html',
  styleUrl: './sequence-management.component.scss'
})
export class SequenceManagementComponent implements OnInit {
  version = environment.version;
  activeFile = environment.activeFile;

  private sequenceService = inject(SequenceService);
  private messageService = inject(MessageService);
  sequences: {
    count: number;
    cust_location: string;
    seqid: string;
  }[] = [];
  totalSequences: number = 0;

  loadingSequences = false;
  archivingSequences = false;

  selectedSeqIDGroup: {
    count: number;
    cust_location: string;
    seqid: string;
  };

  seqIDSequences: MPISequenceDto[] = [];
  totalSeqIDSequences: number = 0;
  private lastTableLazyLoadEvent: TableLazyLoadEvent;

  showAllSequences: boolean = false;

  constructor(
    private trpcService: TrpcService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.trpcService.currentLocationObservable.subscribe((location: string) => {
      this.titleService.setTitle(`Sequence Management | ${location}`);
    })
  }

  async loadSequences(event: TableLazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    this.loadingSequences = true;
    this.sequences = [];
    this.totalSequences = 0;
    this.totalSeqIDSequences = 0;
    this.seqIDSequences = [];

    this.sequenceService.getSequencesCount(event, this.showAllSequences).then(
      (count) => {
        this.totalSequences = count;
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
        this.totalSequences = 0;
      });

    const response = await this.sequenceService.getSequences(event, this.showAllSequences).catch((error) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      return [];
    });

    this.sequences = response;
    this.loadingSequences = false;
  }

  async getSequenceNumbersForID() {
    this.loadingSequences = true;
    this.seqIDSequences = [];
    this.totalSeqIDSequences = 0;
    await this.loadSequenceNumbersForID(this.selectedSeqIDGroup.cust_location, this.selectedSeqIDGroup.seqid);
    
    this.loadingSequences = false;
  }

  async loadSequenceNumbersForID(location: string, seqid: string, skip: number = 0, limit: number = 10) {
    await this.sequenceService.getSequenceNumbersForSequenceID(location, seqid, skip, limit, this.showAllSequences)
      .then((data) => {
        // Success
        this.seqIDSequences = data.result;
        this.totalSeqIDSequences = data.count;
      }, (error) => {
        // Failure
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
        this.seqIDSequences = [];
        this.totalSeqIDSequences = 0;
        //return { result: [], count: 0 };
      });
  }

  async updateSequencesStatus(sequences: MPISequenceDto[], status: string = 'archived') {
    this.archivingSequences = true;
    const response = await this.sequenceService.updateSequencesStatus(sequences, status).catch((error) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      return false;
    });

    if (response) {
      // If true, sequences were updated, so refresh the table
      await this.loadSequenceNumbersForID(this.selectedSeqIDGroup.cust_location, this.selectedSeqIDGroup.seqid);
    }

    this.archivingSequences = false;
  }

  async refreshSequences(): Promise<void> {
    await this.loadSequences(this.lastTableLazyLoadEvent);
    if(this.selectedSeqIDGroup) {
      await this.loadSequenceNumbersForID(this.selectedSeqIDGroup.cust_location, this.selectedSeqIDGroup.seqid);
    }
  }
}
